/* Compagnons de Cœur — page atelier unique (lot I, 02/10/2026), sections/cdc-atelier-page.liquid.
 * - Each product card is checked like the planche pages: proposed only if /api/atelier/public answers { enabled: true } within 3 s;
 *   any other answer, an error or a delay hides it.
 * - Two groups (portraits, then engravings), each with its heading; a group whose keys are all closed is hidden.
 * - Choosing a card mounts that product's Atelier below with CDCAtelier.mount (the same iframe on every switch, so the cart bridges
 *   keep it), with entry 'page-atelier' (PostHog entry_context). The list folds into « Vous personnalisez … · Changer de produit ».
 * - ?produit=<handle> is written on each choice (replaceState, the other parameters kept) and read on arrival: share and resume.
 *   The creation in progress is kept by the Atelier itself (its own resume).
 * - Without this script, each card is a plain link to its product page. */
(function () {
  'use strict';
  var root = document.querySelector('[data-cdc-atelier-page]');
  var atelier = window.CDCAtelier;
  if (!root || !atelier) return;
  var LIMIT = 3000;
  var ID = /^\d{1,20}$/;
  var HANDLE = /^[a-z0-9][a-z0-9-]{0,254}$/;
  var container = root.querySelector('[data-cdc-atelier]');
  var lists = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-ap-list]'));
  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-ap-group]'));
  var choice = root.querySelector('[data-cdc-ap-choice]');
  var status = root.querySelector('[data-cdc-ap-status]');
  var current = root.querySelector('[data-cdc-ap-current]');
  var currentTitle = root.querySelector('[data-cdc-ap-current-title]');
  var currentImage = root.querySelector('[data-cdc-ap-current-image]');
  var change = root.querySelector('[data-cdc-ap-change]');
  if (!container || !lists.length || !choice || !status || !current || !currentTitle || !currentImage || !change) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-cdc-ap-item]')).filter(function (item) {
    return ID.test(item.getAttribute('data-product-id') || '') && HANDLE.test(item.getAttribute('data-handle') || '');
  });
  var selected = null;
  var wanted = '';
  try { wanted = new window.URLSearchParams(window.location.search).get('produit') || ''; } catch (_) { wanted = ''; }
  if (!HANDLE.test(wanted)) wanted = '';

  function smooth() { return !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  // The theme's header comes back, fixed, when the page scrolls up (51 px on mobile, 151 px on desktop), which a choice made lower
  // in the list does: its height is kept clear above the element brought into view.
  function headerHeight() {
    var tallest = 0;
    Array.prototype.forEach.call(document.querySelectorAll('[class*="header__content"]'), function (element) {
      var height = element.getBoundingClientRect().height;
      if (height > 0 && height < window.innerHeight / 2) tallest = Math.max(tallest, height);
    });
    return tallest;
  }
  function bringIntoView(element) {
    var top = Math.max(0, element.getBoundingClientRect().top + window.pageYOffset - headerHeight() - 12);
    window.scrollTo({ top: top, behavior: smooth() ? 'smooth' : 'auto' });
  }
  function say(text, linkText, href) {
    status.textContent = text;
    if (linkText) {
      var link = document.createElement('a');
      link.href = href;
      link.textContent = linkText;
      status.appendChild(link);
      status.appendChild(document.createTextNode('.'));
    }
    status.hidden = !text;
  }

  // The Atelier key of one product, read like the planche pages: only { enabled: true } within 3 s opens it.
  function isOpen(productId) {
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var timer = 0;
    var late = new Promise(function (resolve) {
      timer = window.setTimeout(function () { if (controller) controller.abort(); resolve(false); }, LIMIT);
    });
    var asked = window.fetch(atelier.engine + '/api/atelier/public?productId=' + productId,
      { method: 'GET', credentials: 'omit', cache: 'no-store', signal: controller ? controller.signal : undefined })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (body) { return Boolean(body) && body.enabled === true; }, function () { return false; });
    return Promise.race([asked, late]).then(function (open) { window.clearTimeout(timer); return open; });
  }

  function writeUrl(handle) {
    try {
      var url = new window.URL(window.location.href);
      url.searchParams.set('produit', handle);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (_) { /* the choice still works without the address */ }
  }
  function fold(folded) {
    choice.hidden = folded;
    current.hidden = !folded;
  }
  function choose(item, byVisitor) {
    selected = item;
    items.forEach(function (other) {
      var link = other.querySelector('[data-cdc-ap-choose]');
      if (link) link.setAttribute('aria-current', other === item ? 'true' : 'false');
    });
    var title = item.getAttribute('data-title') || '';
    currentTitle.textContent = title;
    var image = item.querySelector('img');
    var source = image ? image.currentSrc || image.src : '';
    if (source) currentImage.src = source;
    currentImage.hidden = !source;
    say('');
    container.hidden = false;
    atelier.mount(container, { productId: item.getAttribute('data-product-id'), variantId: item.getAttribute('data-variant-id'),
      title: 'Atelier de personnalisation pour ' + title, entry: 'page-atelier' });
    writeUrl(item.getAttribute('data-handle'));
    fold(true);
    if (!byVisitor) return;
    current.setAttribute('tabindex', '-1');
    if (current.focus) current.focus({ preventScroll: true });
    bringIntoView(current);
  }

  choice.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target && event.target.closest ? event.target.closest('[data-cdc-ap-choose]') : null;
    var item = link && link.closest('[data-cdc-ap-item]');
    // Until its key has answered true, a card stays a link to its product page.
    if (!item || items.indexOf(item) === -1 || item.getAttribute('data-open') !== 'true') return;
    event.preventDefault();
    choose(item, true);
  });
  change.addEventListener('click', function () {
    fold(false);
    var link = selected && selected.querySelector('[data-cdc-ap-choose]');
    if (link && link.focus) link.focus({ preventScroll: true });
    bringIntoView(choice);
  });

  lists.forEach(function (list) { list.setAttribute('aria-busy', 'true'); });
  Promise.all(items.map(function (item) {
    return isOpen(item.getAttribute('data-product-id')).then(function (open) {
      if (!open) { item.hidden = true; return false; }
      item.setAttribute('data-open', 'true');
      // ?produit= : the shared or resumed product is mounted as soon as its own key answers.
      if (wanted && !selected && item.getAttribute('data-handle') === wanted) choose(item, false);
      return true;
    });
  })).then(function (answers) {
    lists.forEach(function (list) { list.removeAttribute('aria-busy'); });
    groups.forEach(function (group) {
      var open = Array.prototype.slice.call(group.querySelectorAll('[data-cdc-ap-item]')).some(function (item) { return item.getAttribute('data-open') === 'true'; });
      group.hidden = !open;
    });
    if (answers.indexOf(true) === -1) {
      say('L’atelier est momentanément indisponible. Retrouvez nos créations personnalisables dans ', 'la collection dédiée',
        '/collections/produits-personnalises');
      return;
    }
    var known = items.some(function (item) { return item.getAttribute('data-handle') === wanted; });
    if (wanted && !selected && known) say('Ce produit ne peut pas être personnalisé ici pour le moment. Choisissez-en un autre ci-dessous.');
  });
})();
